// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"fd5c080a","102":"f82aaf60","185":"328ce180","238":"0285e898","357":"b14fedb6","539":"36d0def1","881":"22fc7aee"}[chunkId] + ".chunk.js";
};